import { Globe } from 'lucide-react';
import { useCompanyTimezone } from '@/hooks/useCompanyTimezone';
import { companyTimezoneHint } from '@/lib/timesheetTime';
import { cn } from '@/lib/utils';

/**
 * Small inline note clarifying that timesheet times are rendered in the
 * company's timezone (General Settings), not the viewer's device timezone.
 */
export const CompanyTimezoneHint = ({ className }: { className?: string }) => {
  const timezone = useCompanyTimezone();
  return (
    <p className={cn('flex items-center gap-1.5 text-xs text-muted-foreground', className)}>
      <Globe className="h-3.5 w-3.5 shrink-0" />
      <span>{companyTimezoneHint(timezone)}</span>
    </p>
  );
};
